import React from 'react';
import './about.css'; // Importing the CSS for this component

const About = () => {
  const stats = [
    { value: "50+", label: "Projects Completed" },
    { value: "30+", label: "Happy Clients" },
    { value: "5+", label: "Years Experience" },
    { value: "10+", label: "Team Members" }
  ];

  return (
    <div className="about-page">
      <div className="about-main-container">
        {/* Left Side: Text and Core Items */}
        <div className="about-text-content">
          <h1 className="about-header">We Didn’t Start as Marketers,<br />We Started as <span>Problem Solvers</span>.</h1>
          <p className="about-intro">


WeCanServe was built on one belief — growth should never rely on guesswork.

Before digital marketing, we were executing large-scale ground campaigns and working closely with brands to understand what truly drives results.

Today, we build structured growth systems designed to scale with clarity, consistency, and measurable impact.
          </p>

          <div className="core-values-list">
            <div className="core-value-item">
              <img src="/about/mission.png" alt="check" className="core-icon" />
              <div>
                <h4>Our Mission</h4>
                <p>To help businesses grow with innovative digital solutions.</p>
              </div>
            </div>

            <div className="core-value-item">
              <img src="/about/vision.png" alt="check" className="core-icon" />
              <div>
                <h4>Our Vision</h4>
                <p>To be a trusted partner for brands seeking digital excellence.</p>
              </div>
            </div>

            <div className="core-value-item">
              <img src="/about/value.png" alt="check" className="core-icon" />
              <div>
                <h4>Our Values</h4>
                <p>Creativity, Transparency, Quality, Results.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Team Image */}
        <div className="about-visual-content">
          <img src="/about/about-us.png" alt="WeCanServe Team" className="team-photo" />
          {/* Subtle background graphic elements */}
          <div className="graphic-decoration top-left"></div>
          <div className="graphic-decoration bottom-right"></div>
        </div>
      </div>

      {/* Bottom Section: Stats Grid */}
      {/* <div className="about-stats-container">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div className="stat-card" key={index}>
              <h2>{stat.value}</h2>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default About;